import React, { useEffect } from 'react';
import { SupplierPackageSummaryProps } from './types';
import { useVwp } from '../VwpContext';
import { Button } from 'react-bootstrap';
import Checkbox from "@ui/Checkbox";
import Loading from "@ui/Loading";
import { default as CheckMarkBadge } from '@assets/icons/vwp/CheckMarkBadge.svg?react';
import { PACKAGES_DEPOSIT, WEDPOINT_REDEEM_RATE } from '@helper/constants';
import { price } from './helpers';

import scss from './SupplierPackageSummary.module.scss';

const SupplierPackageSummary = ({ packageOrder, selectedPackage, isAvailable, redeemWedPoints, addingToCart, handleAddToCart }: SupplierPackageSummaryProps) => {
    const { weddingDate, userDetails } = useVwp();
    const [useWedPoints, setUseWedPoints] = React.useState(true);
    const [wedPointsDiscount, setWedPointsDiscount] = React.useState(0);
    const [totalPrice, setTotalPrice] = React.useState(0);
    const [extrasPrice, setExtrasPrice] = React.useState(0);

    useEffect(() => {
        const packagePrice = selectedPackage?.rrpPrice ?? 0;
        
        const newExtrasPrice = calculateExtrasPrice();
        setExtrasPrice(newExtrasPrice);

        const price = packagePrice + newExtrasPrice;
        const wedPointsBalance = userDetails?.WedPointsBalance ?? 0;
        const newWedPointsDiscount = wedPointsBalance / WEDPOINT_REDEEM_RATE;
        const redeemableAmount = (newWedPointsDiscount + PACKAGES_DEPOSIT) > price ? price - PACKAGES_DEPOSIT : newWedPointsDiscount;

        setWedPointsDiscount(redeemableAmount);
        setTotalPrice(price - (!redeemWedPoints && useWedPoints ? redeemableAmount : 0));
    }, [useWedPoints, redeemWedPoints, userDetails, selectedPackage, packageOrder]);

    const calculateExtrasPrice = () => {
        return packageOrder.extras.reduce((acc, extra) => {
          const packageExtra = selectedPackage?.extras?.find(e => e.id === extra.extraId);

          if(!packageExtra) {
              console.log('Extra not found', { packageExtras: selectedPackage?.extras, extra: extra.extraId, categoryId: packageOrder.categoryId, packageItemId: packageOrder.packageItemId})
              return acc;
          }

          return acc + (extra.quantity * packageExtra.rrpPrice);
        }, 0);
      }

    const handleAddToCartClick = () => {
        handleAddToCart(useWedPoints);
    };

    return (
        <div className={scss.packageSummaryContainer}>
            <div className={scss.messageContainer}>
                {isAvailable ?
                <>
                    <CheckMarkBadge className={scss.icon} />
                    <div className={scss.message}>
                        Secure now with a fully refundable <strong>$99 deposit</strong>
                    </div>
                </>
                :
                <>
                    <i className={`fa-regular fa-calendar-xmark ${scss.unavailableIcon}`}></i>
                    <div className={scss.message}>
                        This supplier is not available on {!!weddingDate ? <strong>{new Date(weddingDate).toLocaleDateString('en-GB', { weekday: 'short' })} {new Date(weddingDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</strong> : 'your selected wedding date'}
                    </div>
                </>
                }

                
            </div>
            <div className={scss.priceSummary}>
                <div className={scss.subtotal}>Subtotal <span className={scss.subtotalPrice}>{price((selectedPackage?.rrpPrice ?? 0) + extrasPrice, false)}</span></div>
                {!redeemWedPoints && wedPointsDiscount > 0 &&
                    <div className={scss.wedPoints}>
                        <Checkbox isChecked={useWedPoints} className={scss.checkUseWedPoints} onClick={(e) => setUseWedPoints(!!e.target.checked)} disabled={!isAvailable}>
                            Use your WedPoints to save {price(wedPointsDiscount, false)}
                        </Checkbox>
                    </div>
                }
                <div className={scss.total}>Total <span className={scss.totalPrice}>{price(totalPrice, false)}</span></div>
                <Button
                    variant={'primary'}
                    className={scss.addtoCartBtn}
                    disabled={!isAvailable || addingToCart}
                    onClick={handleAddToCartClick}
                >
                    {addingToCart ? <Loading size={'sm'} /> : <span>Add to cart</span>}
                </Button>
            </div>
        </div>
    );
}

export default SupplierPackageSummary;